import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconSelect$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconSelect extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'a05dbde23ee37130c0e1296a9c5c7243b27d8009', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '8b563d8628d3f426066527539e45fb5889311091', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '6779aae9fb9cf198437715e515d723343d57d6dd', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M15 3a1 1 0 0 1 1 1v.5h-1.5V3zm1 3.5v2h-1.5v-2zM8.5 16v-1.5h-2V16zM3 15a1 1 0 0 0 1 1h.5v-1.5H3zm0-2.5v-2h1.5v2zm0-6v2h1.5v-2zM4 3a1 1 0 0 0-1 1v.5h1.5V3zm4.5 0h-2v1.5h2zm2 0h2v1.5h-2zm5.187 13.707 3.139 3.144a.452.452 0 0 0 .724-.072l.316-.317a.454.454 0 0 0 0-.644l-3.148-3.153 1.918-1.241a.326.326 0 0 0-.072-.598l-6.134-1.812a.334.334 0 0 0-.416.417l1.81 6.17a.326.326 0 0 0 .587.081z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-select", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-select"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-select":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconSelect$1);
            }
            break;
    } });
}

const CosmosIconSelect = CosmosIconSelect$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconSelect, defineCustomElement };
